/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  addDecoderSizePrefix,
  addEncoderSizePrefix,
  combineCodec,
  getAddressDecoder,
  getAddressEncoder,
  getArrayDecoder,
  getArrayEncoder,
  getI64Decoder,
  getI64Encoder,
  getOptionDecoder,
  getOptionEncoder,
  getStructDecoder,
  getStructEncoder,
  getU32Decoder,
  getU32Encoder,
  getUtf8Decoder,
  getUtf8Encoder,
  type Address,
  type Codec,
  type Decoder,
  type Encoder,
  type Option,
  type OptionOrNullable,
} from "@solana/kit";

/** Review schedule for policies */
export type ReviewSchedule = {
  /** Review frequency */
  frequency: bigint;
  /** Last review date */
  lastReview: Option<bigint>;
  /** Next review date */
  nextReview: bigint;
  /** Review owners */
  reviewOwners: Array<Address>;
  /** Review criteria */
  reviewCriteria: Array<string>;
};

export type ReviewScheduleArgs = {
  /** Review frequency */
  frequency: number | bigint;
  /** Last review date */
  lastReview: OptionOrNullable<number | bigint>;
  /** Next review date */
  nextReview: number | bigint;
  /** Review owners */
  reviewOwners: Array<Address>;
  /** Review criteria */
  reviewCriteria: Array<string>;
};

export function getReviewScheduleEncoder(): Encoder<ReviewScheduleArgs> {
  return getStructEncoder([
    ["frequency", getI64Encoder()],
    ["lastReview", getOptionEncoder(getI64Encoder())],
    ["nextReview", getI64Encoder()],
    ["reviewOwners", getArrayEncoder(getAddressEncoder())],
    [
      "reviewCriteria",
      getArrayEncoder(addEncoderSizePrefix(getUtf8Encoder(), getU32Encoder())),
    ],
  ]);
}

export function getReviewScheduleDecoder(): Decoder<ReviewSchedule> {
  return getStructDecoder([
    ["frequency", getI64Decoder()],
    ["lastReview", getOptionDecoder(getI64Decoder())],
    ["nextReview", getI64Decoder()],
    ["reviewOwners", getArrayDecoder(getAddressDecoder())],
    [
      "reviewCriteria",
      getArrayDecoder(addDecoderSizePrefix(getUtf8Decoder(), getU32Decoder())),
    ],
  ]);
}

export function getReviewScheduleCodec(): Codec<
  ReviewScheduleArgs,
  ReviewSchedule
> {
  return combineCodec(getReviewScheduleEncoder(), getReviewScheduleDecoder());
}
